import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  initializeAuth,
  browserLocalPersistence,
  indexedDBLocalPersistence,
  browserPopupRedirectResolver,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY ||
    "AIzaSyCtFtbNCt6zH9iYBwSSdRbwZKYDC8PnIyc",
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ||
    (import.meta.env.DEV
      ? "velasquez-spending-dashboard.firebaseapp.com"
      : "velasquez-home.com"),
  projectId: "velasquez-spending-dashboard",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    "velasquez-spending-dashboard.firebasestorage.app",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "832682981042",
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ||
    "1:832682981042:web:9460f1b2eaf781baea7bab",
};

let app;
let auth;

if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
  auth = initializeAuth(app, {
    persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    popupRedirectResolver: browserPopupRedirectResolver,
  });
} else {
  app = getApps()[0];
  auth = getAuth(app);
}

export { auth };
export const db = getFirestore(app);

export default app;
